import { Button } from '@orobix/orobix-fe-components'
import { useTranslation } from 'react-i18next'

interface ButtonNewProjectProps {
  setProjectsCreateUpdateModal: React.Dispatch<React.SetStateAction<boolean>>
}

const ButtonNewProject = ({
  setProjectsCreateUpdateModal,
}: ButtonNewProjectProps) => {
  const { t } = useTranslation()

  return (
    <Button
      onClick={() => setProjectsCreateUpdateModal(true)}
      label={t('New project')}
      buttonType="button"
      type="action"
      size="md"
    />
  )
}

export default ButtonNewProject
